export default {
  topBar: {
    device: {
      deviceRotate: 'Device resolution',
      select: 'select please',
    },
    playScene: {
      play: 'Play the scene',
      pause: 'Return to initial state',
    },
  },
  takeColor: {
    bindEventMessage: 'The game is not loaded',
  },
  bottomBar: {
    scaleManager: {
      validateTips: 'value between 50 and 200',
    },
    estimateSize: {
      packageEstimate: 'Package Size Estimation',
      packageEstimating: 'Estimating',
      packageEstimateTip:
        'Please check the package size regularly during production to avoid exceeding the size limit.',
      high: 'High quality',
      middle: 'Medium quality',
      low: 'Low quality',
      packageLimitTip: 'Package size limit',
    },
  },
  device: {
    orientationList: {
      horizontal: 'Landscape',
      portrait: 'Portrait',
    },
    adaptToTheScreen: 'Adapt to Screen',
  },
}
